export default __webpack_public_path__ + "static/bannerHomePageBg-2e215d00a40123933efebb419f43ad55.png";